export const environment = {
  name: 'production',
  production: true,
  spotId: 'sp_s81DnEgR',
  debug: false,
  stripePublishableKey: 'pk_0zIUNvWdQMQTgAAOcX1k9p5BOUXTz',
  recaptchaV2SiteKey: '6LfORrIZAAAAADh6jtBF5aMhuEc3XfLjN4wBwepR',
  recaptchaV3SiteKey: '6LfsRbIZAAAAAMcH0NLIDxSqvJy3JNUs3XpWxQ4L',
  showDevTools: false,
  showDevNotes: false,
  settings: {
    allowImmediateCancel: false,
    enableBeacons: true,
    enableStagingNotes: false
  },

  /** @deprecated */
  environment: 'production',
  urls: {
      app: 'https://tyt.com',
      accounts: 'https://accounts.tyt.com',
      purchase: 'https://accounts.tyt.com/join',
      donate: 'https://secure.actblue.com/donate/tytnetwork',
      platform: 'https://platform.tytnetwork.com',
      cable: 'https://platform.tyt.com/cable',
      api: 'https://platform.tyt.com/api/v1',
      admin: 'https://platform.tyt.com',
      forums: 'https://discuss.tyt.com',
      bantaServer: 'https://banta.tyt.com',
      cdn: 'cdn2.tyt.com'
  },
  auth: {
      domain: '.tyt.com',
      cookie: 'tytauth',
      userCookie: 'tyt_user_uuid'
  },
};
